<template>
  <!-- A nota da folha corrigida: "4/5" em Poppins, circulado a caneta. O
       circulo se desenha uma vez, quando a nota aparece (sem animacao para
       quem pede menos movimento). -->
  <div
    class="score"
    :class="{ 'score--small': small }"
    role="img"
    :aria-label="label"
  >
    <svg class="score__ring" viewBox="0 0 200 120" aria-hidden="true">
      <path
        :class="['score__stroke', { 'score__stroke--draw': animate }]"
        d="M152 22 C 118 6, 52 8, 26 34 C 2 58, 18 98, 74 108 C 132 118, 186 98, 186 62 C 186 34, 150 16, 104 15"
      />
    </svg>
    <span class="score__num">
      {{ correct }}<span class="score__slash">/</span>{{ total }}
    </span>
  </div>
</template>

<script>
export default {
  name: "ScoreMark",
  props: {
    correct: { type: Number, required: true },
    total: { type: Number, required: true },
    animate: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
  },
  computed: {
    label() {
      return this.$t("exercises.scoreAria", {
        correct: this.correct,
        total: this.total,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.score {
  position: relative;
  display: inline-grid;
  place-items: center;
  width: 150px;
  height: 92px;
  flex-shrink: 0;
}

.score__ring {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.score__stroke {
  fill: none;
  stroke: var(--dk-grape, #a826e1);
  stroke-width: 3.2;
  stroke-linecap: round;
  stroke-dasharray: 520;
  stroke-dashoffset: 0;
}

.score__stroke--draw {
  stroke-dashoffset: 520;
  animation: score-draw 700ms 200ms cubic-bezier(0.6, 0.05, 0.3, 1) forwards;
}

.score__num {
  position: relative;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 1;
  color: var(--dk-ink, #2b2540);
  font-variant-numeric: tabular-nums;
}

.score__slash {
  margin: 0 2px;
  font-weight: 500;
  color: #a39cb3;
}

.score--small {
  width: 84px;
  height: 52px;
}

.score--small .score__num {
  font-size: 20px;
}

@keyframes score-draw {
  to {
    stroke-dashoffset: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .score__stroke--draw {
    animation: none;
    stroke-dashoffset: 0;
  }
}
</style>
